import { useNavigationDrawerValues } from 'components/navigation_drawer/navigation_drawer_store';
import { NavigationDrawerFooter } from 'components/navigation_drawer/NavigationDrawerFooter';
import { NavigationDrawerHeader } from 'components/navigation_drawer/NavigationDrawerHeader';
import { NavigationDrawerItem } from 'components/navigation_drawer/NavigationDrawerItem';
import {
    NavigationDrawerItems,
    NavigationDrawerWrapper,
} from 'components/navigation_drawer/styled';
import { useMemo } from 'react';

export function NavigationDrawer() {
    const {
        items,
        itemExpanded,
        isDrawerExpanded,
        toggleItemExpanded,
    } = useNavigationDrawerValues((state) => ({
        items: state.items,
        itemExpanded: state.itemExpanded,
        isDrawerExpanded: state.isDrawerExpanded,
        toggleItemExpanded: state.toggleItemExpanded,
    }));

    const enabledItems = useMemo(() => items.filter((item) => item.enabled), [items]);

    return (
        <NavigationDrawerWrapper
            id="navigation-drawer"
            aria-label="Navigation Drawer"
            $expanded={isDrawerExpanded}
        >
            <NavigationDrawerHeader />
            <NavigationDrawerItems>
                {enabledItems.map((item) => (
                    <NavigationDrawerItem
                        {...item}
                        key={item.id}
                        isDrawerExpanded={isDrawerExpanded}
                        isExpanded={itemExpanded === item}
                        onClick={() => toggleItemExpanded(item)}
                    />
                ))}
            </NavigationDrawerItems>
            <NavigationDrawerFooter />
        </NavigationDrawerWrapper>
    );
}
